import { NavLink, useLocation } from "react-router-dom";

// Sub-pages kept reachable under the 6 sidebar sections.
export const GROUPS = [
    {
        key: "videos", match: ["/videos", "/content", "/onboard"],
        tabs: [["/videos", "All videos"], ["/content/modules", "Manage content"], ["/onboard", "New video"], ["/present/34b7315c-0fb6-4447-a405-b739f1a041d5", "Present demo"]],
    },
    {
        key: "documents", match: ["/knowledge"],
        tabs: [["/knowledge/documents", "Documents"], ["/knowledge/upload", "Upload"], ["/knowledge/reviews", "Reviews"], ["/knowledge/revisions", "Revisions"]],
    },
    {
        key: "learners", match: ["/learning"],
        tabs: [["/learning/learners", "Learners"], ["/learning/assignments", "Assignments"], ["/learning/assessments", "Assessments"], ["/learning/certificates", "Certificates"]],
    },
    {
        key: "settings", match: ["/settings", "/admin"],
        tabs: [["/settings", "Overview"], ["/admin/users", "Users"], ["/admin/organisation", "Organisation"], ["/admin/branding", "Branding"], ["/admin/usage", "Usage"], ["/admin/audit-log", "Audit log"], ["/admin/integrations", "API keys"], ["/admin/ai-settings", "AI settings"]],
    },
];

export const groupFor = (path) => GROUPS.find((g) => g.match.some((m) => path === m || path.startsWith(`${m}/`)));

export default function SectionTabs() {
    const { pathname } = useLocation();
    const g = groupFor(pathname);
    if (!g || /^\/videos\/[^/]+/.test(pathname)) return null;
    return (
        <nav data-testid={`section-tabs-${g.key}`} className="mb-8 flex flex-wrap gap-1 border-b border-neutral-200">
            {g.tabs.map(([to, label]) => (
                <NavLink key={to} to={to} end data-testid={`section-tab-${to.replace(/\//g, "-").slice(1)}`}
                    className={({ isActive }) => `-mb-px border-b-2 px-3 py-2 text-sm ${isActive ? "border-neutral-900 font-medium text-neutral-900" : "border-transparent text-neutral-500 hover:text-neutral-900"}`}>
                    {label}
                </NavLink>
            ))}
        </nav>
    );
}
